import { Route } from 'react-router-dom';
import { InvestmentManagePersonalIDs } from '@dealstack/frontend/investor/pages/Investment/InvestmentManage/RejectedFiles/InvestmentManagePersonalIDs/InvestmentManagePersonalIDs';
import { InvestmentManagePIVProof } from '@dealstack/frontend/investor/pages/Investment/InvestmentManage/RejectedFiles/InvestmentManagePIVProofs/InvestmentManagePIVProof';
import { InvestmentManageDeclarations } from '@dealstack/frontend/investor/pages/Investment/InvestmentManage/RejectedFiles/InvestmentManageDeclarations/InvestmentManageDeclarations';
import { SentryRoutes } from '@dealstack/frontend/shared/sentry';
import { InvestmentKycForms } from '@dealstack/frontend/investor/pages/Investment/common/InvestmentKycForms';
import { Box } from '@mantine/core';
import {
	GetInvestmentDetailsRes,
	KycWorkflowSettingResponseDto,
} from '@dealstack/shared/lib/generated';
import { InlineLoader } from '@dealstack/frontend/shared/components/loaders/InlineLoader/InlineLoader';
import { getKycWorkflowId } from '@dealstack/frontend/investor/pages/Investment/common/getKycWorkflowId';

export enum REJECTED_FILES_ROUTES {
	PERSONAL = '/personal',
	COMPANY = '/company',
	KYC_FORMS = '/kyc-forms',
	DECLARATIONS = '/declarations',
}

interface Props {
	setIsContinueDisabled: (isContinueDisabled: boolean) => void;
	investmentDetails: GetInvestmentDetailsRes | undefined;
	isPIVInvestment: boolean;
	setIsLoading: (isLoading: boolean) => void;
	kycSetting: KycWorkflowSettingResponseDto | undefined;
}

export const RejectedFiles = ({
	setIsContinueDisabled,
	investmentDetails,
	isPIVInvestment,
	setIsLoading,
	kycSetting,
}: Props) => {
	const kycWorkflowId = getKycWorkflowId(investmentDetails);

	if (!kycWorkflowId) {
		return <InlineLoader />;
	}
	return (
		<Box maw="70rem">
			<SentryRoutes>
				<Route
					path={REJECTED_FILES_ROUTES.PERSONAL}
					element={
						<InvestmentManagePersonalIDs
							setIsContinueDisabled={setIsContinueDisabled}
							kycWorkflowId={kycWorkflowId}
							kycSetting={kycSetting}
						/>
					}
				/>
				<Route
					path={REJECTED_FILES_ROUTES.COMPANY}
					element={
						<InvestmentManagePIVProof
							setIsContinueDisabled={setIsContinueDisabled}
							investmentDetails={investmentDetails}
							kycWorkflowId={kycWorkflowId}
							kycSetting={kycSetting}
						/>
					}
				/>
				<Route
					path={REJECTED_FILES_ROUTES.KYC_FORMS}
					element={
						<InvestmentKycForms
							setIsContinueDisabled={setIsContinueDisabled}
							isPIVInvestment={isPIVInvestment}
							kycWorkflowId={kycWorkflowId}
						/>
					}
				/>
				<Route
					path={REJECTED_FILES_ROUTES.DECLARATIONS}
					element={
						<InvestmentManageDeclarations
							setIsContinueDisabled={setIsContinueDisabled}
							setIsLoading={setIsLoading}
							isPIVInvestment={isPIVInvestment}
							kycWorkflowId={kycWorkflowId}
							kycSetting={kycSetting}
						/>
					}
				/>
			</SentryRoutes>
		</Box>
	);
};
